<template>
    <div  class="custom-historico" v-show='getShowHistory'>
		<div class="container-fluid">
			<div class="row mt-2 mb-2">
				<div class="col-md-12">
					<h3 class="text-center border-bottom-hist">Histórico</h3>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-4">
				<label for='de'>De</label>
				<input type="date" class="form-control" id="de" name="begin" v-model="begin"/>
			</div>
			<div class="col-md-4">
				<label for="ate">Ate</label>
				<input type='date' class="form-control" id="ate" name="end" v-model="end">
			</div>
			<div>
				<button class="button-modal btn btn-secondary" type="button" @click.prevent="shareHistory()" style="margin-top: 30px;">Pesquisar</button>
			</div>
			<div class="check">
				<label for="checkbox"> Conferir meus atendimentos? </label>
				<input type="checkbox" id="checkbox" v-model="checked" :disabled="domCheck"> 
			</div>
		</div>
		<tableHistory></tableHistory>
		<logModal></logModaL>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import ocurrences from '../../../store/modules/ocurrences'

export default {
    computed:{
        ...mapGetters(['getShowHistory', 'oneClient', 'getChannel', 'getCurrentConversaIndex'])
	},
	watch: {
		getShowHistory: function(){
			this.checkdom()
		}
	},
    methods:{
		...mapActions(['fetchOcurrences']),
		
        shareHistory(){

			this.checkdom();
			
			axios.get('/getAttendanceByCNPJ', { params: 
				{ 
					cnpj: this.oneClient.cpf_cnpj,
					begin: this.begin,
					end: this.end,
					check: this.checked
				} 
			}).then(data => {
				this.fetchOcurrences(data.data);
			})
			
			this.begin = '';
			this.end = '';
		},
		checkdom(){
			this.domCheck = (this.getChannel() != '' || this.getCurrentConversaIndex !== ''); 
			if(this.domCheck){
				this.checked = false;
			}
		}
	},

    data(){
		
        return{
            begin:'',
			end:'',
			checked: false,
			domCheck: false
        }
    },

}
</script>

<style>
	.border-bottom-hist{
		border-bottom: solid 2px #1C869A;
	}
	.check{
		margin-top: 2.6em;
    	margin-left: 1em;
	}
	.custom-historico {
		display: flex;
		flex-direction: column;
		padding: 0.4rem 2rem 2rem;
	}
	.show-plus{
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.tables th,.tables td  {
		border: none;
	}
	.tables tr:nth-child(even) {
		background-color: rgba(0, 0, 0, 0.05);
	}
	.tables th {
		background-color: #1c869a;
		color:white;
		padding: 8px;
		border:groove 1px lightgray
	}
</style>
